const outside=require("./outside"),gtr=(version,range,options)=>outside(version,range,">",options);module.exports=gtr;